module.exports = __webpack_public_path__ + "img/118.811cf5e4.jpg";